var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6815 0.576172C11.0957 0.576172 8.61571 1.6034 6.78723 3.43188C4.95875 5.26036 3.93152 7.74031 3.93152 10.3262H0.681519L4.89569 14.5403L4.97152 14.692L9.34819 10.3262H6.09819C6.09819 6.13367 9.48902 2.74284 13.6815 2.74284C17.874 2.74284 21.2649 6.13367 21.2649 10.3262C21.2649 14.5187 17.874 17.9095 13.6815 17.9095C11.5907 17.9095 9.69485 17.0537 8.32985 15.6778L6.79152 17.2162C7.69438 18.124 8.76805 18.8441 9.95059 19.335C11.1331 19.8259 12.4011 20.0778 13.6815 20.0762C16.2674 20.0762 18.7473 19.0489 20.5758 17.2205C22.4043 15.392 23.4315 12.912 23.4315 10.3262C23.4315 7.74031 22.4043 5.26036 20.5758 3.43188C18.7473 1.6034 16.2674 0.576172 13.6815 0.576172ZM12.5982 5.99284V11.4095L17.2349 14.1612L18.0149 12.8503L14.2232 10.597V5.99284H12.5982Z",
    fill: "#0097BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeHistory);
export default __webpack_public_path__ + "static/media/change-history.87feecede2264b28de01d05a318184c2.svg";
export { ForwardRef as ReactComponent };